import { render, staticRenderFns } from "./QuestionSlider.vue?vue&type=template&id=048d1d2a"
import script from "./QuestionSlider.vue?vue&type=script&lang=js"
export * from "./QuestionSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports